import { render, staticRenderFns } from "./TreeselectCustom.vue?vue&type=template&id=6144ed71&scoped=true&"
import script from "./TreeselectCustom.vue?vue&type=script&lang=js&"
export * from "./TreeselectCustom.vue?vue&type=script&lang=js&"
import style0 from "./TreeselectCustom.vue?vue&type=style&index=0&id=6144ed71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6144ed71",
  null
  
)

export default component.exports